import { useState, useEffect } from "react";
import { ModalBody, Label, Input, Select, Common, DateRangeInput } from "@lainco/react-toolbox";
import { withModal } from "../components/Modal";
import { startOfToday } from "date-fns";
import { Balance } from "../components/cashflows/Balance";
import styled from "styled-components";
import { useItems } from "../app/browsersSlice";
import { InputNumber } from "../components/InputNumber";

export function MultiplesBankAccountBalancesModalContent({ bank, company, model, onChange }) {
  const [allAccounts, allAccountsLoading] = useItems("bankAccounts");

  console.log("Modal received", { bank, company });

  useEffect(() => {
    if (allAccounts && bank && company) {
      const filtered = allAccounts
        .filter((x) => x.bank.id === bank.bank?.id && x.company.id === company.company?.id)
        .map((x) => ({ balance: null, account: x }));
      onChange(filtered);
    }
  }, [allAccounts, bank, company]);

  console.log({ bank, company, allAccounts, model });
  return (
    <ModalBody>
      <Common.Grid rows="auto auto auto" cols="1fr 1fr" gap="1em">
        <Label text="Company">
          <Input value={company?.name} disabled outline />
        </Label>
        <Label text="Bank">
          <Input value={bank?.name} disabled outline />
        </Label>
        <Label text="Date" colSpan="2">
          <div style={{ fontSize: "1.2em" }}>
            <DateRangeInput type="date" date={startOfToday()} outline disabled />
          </div>
        </Label>
        <Label text="Balances" info="Enter balances for each bank account, left empty to maintain current balance" colSpan="2">
          {allAccountsLoading ? (
            "Loading..."
          ) : (
            <Common.Row cols="auto" gap="1em">
              {model?.map((x, i) => (
                <Common.Row cols="9em 1fr 1fr">
                  <Title>{x.account.getDisplayName()}</Title>
                  <InputNumber
                    key={x.account.id}
                    value={x.balance}
                    onChange={(v) => {
                      const newAccounts = [...model];
                      newAccounts[i].balance = v;
                      onChange(newAccounts);
                    }}
                    outline
                  />
                  <Balance account={{ model: x.account }} showTitle={false} />
                </Common.Row>
              ))}
            </Common.Row>
          )}
        </Label>
      </Common.Grid>
    </ModalBody>
  );
}

export default withModal(MultiplesBankAccountBalancesModalContent, "Bank Balances", "Save", "lg");

const Title = styled.span`
  color: black;
  font-variant: small-caps;
`;
